















import { defineComponent } from "@vue/composition-api"
import axios from "axios"

const severityIconScheme: { [key: string]: { icon: string; color: string } } = {
  info: { icon: "mdi-information-variant", color: "primary" },
  warning: { icon: "mdi-alert", color: "warning" },
  error: { icon: "mdi-exclamation-thick", color: "error" },
  help: { icon: "mdi-help", color: "secondary" },
  fallback: { icon: "mdi-bug-outline", color: "purple" },
}
const toIcon = (severity: string) => (severityIconScheme[severity] || severityIconScheme.fallback).icon
const toColor = (severity: string) => (severityIconScheme[severity] || severityIconScheme.fallback).color

export default defineComponent({
  setup: () => ({
    toIcon,
    toColor,
  }),
  data() {
    return {
      news: { data: null },
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_WBC_BASE_URL + "/WBCWebService/GetNotice?title=sacra-notice", {
        headers: {
          "app-id": "AIzaSyAFI0pqUwt4LpowsfRAVRxXbFg_49Bp5fM",
        },
      })
      .then((response) => (this.news = response.data))
  },
  methods: {
    getDate: function (date: string) {
      let str: string[] = date.split(" ")
      return str[0]
    },
  },
})
